import React, { useState, useEffect, useRef, useContext } from "react";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AuthContext } from "../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { FileUpload } from 'primereact/fileupload';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { useSessionHelper } from '../../../custom/sessionHelper';
import { openSessionModal } from '../../../store/sessionModalSlice';
import CustomDropdown from '../../../custom/customDropdown';
import handlePrintInvoice from './faktureStrane/fakturaStampa';
import { exportInvoiceWithFiles } from './faktureStrane/exportInvoiceWithFiles';
import { exportInvoiceToExcel } from './faktureStrane/exportInvoiceToExcel';

function toUtcIso(d) {
  if (!d) return null;
  const x = d instanceof Date ? d : new Date(d);
  const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
  return utc.toISOString().slice(0, 19) + 'Z';
}

const PregledPredracuna = (props) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user);
  const invoice = useSelector(state => state.invoice);
  const { sessionHelper } = useSessionHelper();
  const dispatch = useDispatch();

  // — predračuni tabela —
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
  const [selectedRowId, setSelectedRowId] = useState(null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [izabranPredracun, setIzabranPredracun] = useState(null); // ceo row

  // — avansni tabela —
  const [avansniData, setAvansniData] = useState([]);
  const [avansniLoading, setAvansniLoading] = useState(false);
  const [selectedAvansniId, setSelectedAvansniId] = useState(null);

  // — SEF (avansni/konačni) —
  const [sefKonfigurisan, setSefKonfigurisan] = useState(false);
  const [sefRazlog, setSefRazlog] = useState('');
  const [sefSendingId, setSefSendingId] = useState(null);

  // — tab Avansni računi (sve izdate avansne fakture, nezavisno od izabranog predračuna) —
  const [aktivniTab, setAktivniTab] = useState(0);
  const [sviAvansniData, setSviAvansniData] = useState(null);
  const [globalFilterAvansni, setGlobalFilterAvansni] = useState(null);
  const sviAvansniColumnsAll = [
    { label: 'Broj avansnog', value: 'BrojPrikaz' },
    { label: 'Predračun', value: 'BrojPredracuna' },
    { label: 'Klijent', value: 'Klijent' },
    { label: 'Iznos', value: 'Iznos' },
    { label: 'Datum uplate', value: 'Datum uplate' },
    { label: 'Kreiran', value: 'Datum unosa' },
    { label: 'SEF status', value: 'sefStatus' },
    { label: 'SEF komentar', value: 'sefKomentar' },
  ];
  const [selectedSviAvansniColumns, setSelectedSviAvansniColumns] = useState(sviAvansniColumnsAll.map(c => c.value));

  const loadSviAvansni = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAllAvansniRacuni', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
    })
      .then(handleErrors)
      .then(data => setSviAvansniData(data || []))
      .catch(() => setSviAvansniData([]));
  };

  // — forma avansni/konačni —
  const [formData, setFormData] = useState({ id_tip_racuna: 307, Iznos: null, IznosValuta: 220, datumUplate: null, Napomena: '' });
  const [mesecKonacni, setMesecKonacni] = useState(new Date());
  const [previewKonacni, setPreviewKonacni] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  // — opcije za formu (iz INIT stepa) —
  const [tipoviOptions, setTipoviOptions] = useState([]);
  const [valuteOptions, setValuteOptions] = useState([]);

  const handleErrors = (res) => {
    if (res.ok) return res.json();
    throw res;
  };

  // IDs predračuna koji imaju alarm (avansni bez konačnog)
  const [alarmPredracunIds, setAlarmPredracunIds] = useState(new Set());
  // IDs predračuna gde je konačni izdat ali nije naplaćena
  const [orangePredracunIds, setOrangePredracunIds] = useState(new Set());

  // ─── Učitaj predračune ───────────────────────────────────────────────────────
  const loadPredracuni = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetALLInvoicesData', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ tip: 303, pregled: 'AVANS' }),
    })
      .then(handleErrors)
      .then(async (data) => {
        setTableData(data);
        if (data && data.length > 0) {
          const EXCLUDED_PREDRACUN_COLS = ['ID', 'Valuta', 'Valute iznosa', 'Status SEF-a', 'SEF status'];
          const cols = Object.keys(data[0])
            .filter(k => !EXCLUDED_PREDRACUN_COLS.includes(k))
            .map(k => ({ label: k, value: k }));
          setAllColumns(cols);
          setOriginalColumnOrder(Object.keys(data[0]));
          const cfgRes = await fetch(process.env.REACT_APP_BACKEND_URL + '/config/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ id_config: 310 }),
          }).then(r => r.json());
          if (cfgRes?.length > 0) {
            let savedCols = JSON.parse(cfgRes[0].parametri).filter(k => !EXCLUDED_PREDRACUN_COLS.includes(k));
            if (!savedCols.includes('Status')) {
              const idx = savedCols.indexOf('Izaberi');
              savedCols.splice(idx >= 0 ? idx + 1 : 0, 0, 'Status');
            }
            setSelectedColumns(savedCols);
          } else {
            setSelectedColumns(cols.slice(0, 5).map(c => c.value));
          }
        }
      })
      .catch(err => err.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 })));
  };

  useEffect(() => {
    if (invoice) dispatch({ type: 'INVOICE', value: null });
    loadPredracuni();
  }, [auth.token, company.companyId]);

  // Učitaj alarm count + IDs predračuna za crvene redove
  const fetchAlarm = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
    }).then(r => r.json()).then(data => {
      const count = data?.[0]?.AlarmCount || 0;
      dispatch({ type: 'AVANS_ALARM_SET', value: count });
      const ids = data?.[0]?.AlarmIds ? new Set(data[0].AlarmIds.split(',').map(s => s.trim())) : new Set();
      setAlarmPredracunIds(ids);
      const orangeIds = data?.[0]?.OrangeIds ? new Set(data[0].OrangeIds.split(',').map(s => s.trim())) : new Set();
      setOrangePredracunIds(orangeIds);
    }).catch(() => {});
  };

  const refreshAlarm = () => fetchAlarm();

  useEffect(() => {
    fetchAlarm();
  }, [auth.token]);

  useEffect(() => {
    if (aktivniTab === 1 && sviAvansniData === null) loadSviAvansni();
  }, [aktivniTab]);

  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/sef/CheckConfig', {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + auth.token },
    })
      .then(r => r.json())
      .then(data => {
        setSefKonfigurisan(data.configured === true);
        setSefRazlog(data.reason || "");
      })
      .catch(() => { setSefKonfigurisan(false); setSefRazlog(""); });
  }, [auth.token]);

  // Učitaj tip i valute opcije iz SP INIT stepa
  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/InitAvansniRacuni', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
    })
      .then(r => r.json())
      .then(data => {
        const jsonStr = data?.[0]?.JsonOutput;
        if (!jsonStr) return;
        const parsed = JSON.parse(jsonStr);
        if (parsed.TipoviDB?.length) setTipoviOptions(parsed.TipoviDB);
        if (parsed.ValuteDB?.length)  setValuteOptions(parsed.ValuteDB.filter(o => ['RSD', 'EUR'].includes(o.label)));
      })
      .catch(() => {});
  }, [auth.token]);

  // ─── Učitaj avansne/konačne za izabrani predračun ───────────────────────────
  const loadAvansni = (id_predracun) => {
    if (!id_predracun) { setAvansniData([]); return; }
    setAvansniLoading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansniRacuni', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id_predracun }),
    })
      .then(handleErrors)
      .then(data => { setAvansniData(data || []); refreshAlarm(); })
      .catch(() => setAvansniData([]))
      .finally(() => setAvansniLoading(false));
  };

  // ─── Selekcija predračuna ────────────────────────────────────────────────────
  const chooseInvoice = async (rowData) => {
    const id = getId(rowData);
    const resultSession = await sessionHelper(user.userId, 'IFAVANS', id);
    if (resultSession.zauzeto) {
      dispatch(openSessionModal({ type: 'SESSION_LOCK', message: resultSession.message }));
      return;
    }
    setSelectedRowId(prev => {
      const next = String(prev) === String(id) ? null : String(id);
      if (next) {
        const row = tableData?.find(t => String(t.Izaberi) === String(rowData.Izaberi));
        setIzabranPredracun(row || null);
        resetForma();
        loadAvansni(rowData.Izaberi);
        dispatch({ type: 'INVOICE', value: rowData.Izaberi });
      } else {
        setIzabranPredracun(null);
        setAvansniData([]);
        resetForma();
        dispatch({ type: 'INVOICE', value: null });
      }
      return next;
    });
  };

  const statusProvereOK = izabranPredracun?.['Status provere'] === 'Prihvaćena';

  const handleEditPredracun = () => {
    if (!izabranPredracun) return;
    const podtip = izabranPredracun['Podtip fakture'];
    props.setIdInvoice(izabranPredracun.Izaberi);
    props.setChangeView(podtip === 'Dinarska faktura' ? 1 : 2);
  };

  // ─── Kreiraj Konačni — prebacuje na NovaDinarska/NovaDevizna sa pre-fillom iz
  // predračuna (nova faktura, ne edit predračuna). Backend vraća jasnu grešku ako
  // su sve stavke predračuna već fakturisane.
  const handleKreirajKonacni = () => {
    if (!izabranPredracun) return;
    if (!statusProvereOK) {
      toast.current.show({
        severity: 'error',
        summary: 'Nije dozvoljeno',
        detail: 'Predračun mora biti proveran i prihvaćen (Status provere = Prihvaćena) pre kreiranja konačne fakture.',
        life: 5000,
      });
      return;
    }
    const podtip = izabranPredracun['Podtip fakture'];
    props.setIdInvoice(null);
    props.setIdPredracunZaKonacni(izabranPredracun.Izaberi);
    props.setChangeView(podtip === 'Dinarska faktura' ? 1 : 2);
  };

  // ─── Forma avansni/konačni ───────────────────────────────────────────────────
  const resetForma = () => {
    setFormData({ id_tip_racuna: 307, Iznos: null, IznosValuta: 220, datumUplate: null, Napomena: '' });
    setSelectedAvansniId(null);
    setFormSubmitted(false);
    setMesecKonacni(new Date());
    setPreviewKonacni([]);
  };

  const loadPreviewKonacni = (mesec, id_predracun) => {
    if (!mesec || !id_predracun) { setPreviewKonacni([]); return; }
    const mesecISO = toUtcIso(new Date(mesec.getFullYear(), mesec.getMonth(), 1)).slice(0, 10);
    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/PreviewKonacni', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id_predracun, mesec: mesecISO }),
    }).then(r => r.json()).then(d => {
      if (d?.[0]?.message) {
        toast.current.show({ severity: 'warn', summary: d[0].message, life: 4000 });
        setPreviewKonacni([]);
      } else {
        setPreviewKonacni(d || []);
      }
    }).catch(() => {});
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target || e;
    if (name === 'id_tip_racuna' && value === 308 && mesecKonacni && izabranPredracun?.Izaberi) {
      loadPreviewKonacni(mesecKonacni, izabranPredracun.Izaberi);
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const chooseAvansni = (rowData) => {
    const id = rowData.ID;
    setSelectedAvansniId(prev => {
      const next = String(prev) === String(id) ? null : String(id);
      if (next) {
        setFormData({
          id_tip_racuna: rowData.id_tip_racuna,
          Iznos: parseFloat(rowData.Iznos) || null,
          IznosValuta: rowData.IznosValuta || 220,
          datumUplate: rowData['Datum uplate'] ? new Date(rowData['Datum uplate'].split('.').reverse().join('-')) : null,
          Napomena: rowData.Napomena || '',
        });
      } else {
        setFormData({ id_tip_racuna: 307, Iznos: null, IznosValuta: 220, datumUplate: null, Napomena: '' });
        setFormSubmitted(false);
      }
      return next;
    });
  };

  const handleSave = () => {
    setFormSubmitted(true);
    if (!statusProvereOK) {
      toast.current.show({
        severity: 'error',
        summary: 'Nije dozvoljeno',
        detail: 'Predračun mora biti proveran i prihvaćen (Status provere = Prihvaćena) pre kreiranja avansnih/konačnih računa.',
        life: 5000,
      });
      return;
    }
    if (!formData.id_tip_racuna || (formData.id_tip_racuna === 307 && !formData.Iznos)) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Tip i iznos su obavezni.', life: 3000 });
      return;
    }
    if (!selectedRowId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali predračun.', life: 3000 });
      return;
    }

    const id_predracun = izabranPredracun?.Izaberi;
    const datumUplateISO = toUtcIso(formData.datumUplate);

    const mesecISO = mesecKonacni instanceof Date
      ? toUtcIso(new Date(mesecKonacni.getFullYear(), mesecKonacni.getMonth(), 1)).slice(0, 10)
      : null;

    if (formData.id_tip_racuna === 308 && !mesecISO) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Izaberite mesec za konačni račun.', life: 3000 });
      return;
    }

    const endpoint = selectedAvansniId ? '/invoice/UpdateAvansniRacun' : '/invoice/InsertAvansniRacun';
    const body = selectedAvansniId
      ? { id: selectedAvansniId, ...formData, datumUplate: datumUplateISO }
      : { id_predracun, ...formData, datumUplate: datumUplateISO, mesec: mesecISO };

    fetch(process.env.REACT_APP_BACKEND_URL + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify(body),
    })
      .then(handleErrors)
      .then(data => {
        if (data?.[0]?.message && !data[0].ID) {
          toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: data[0].message, life: 4000 });
          return;
        }
        toast.current.show({ severity: 'success', summary: selectedAvansniId ? 'Izmena uspešna!' : 'Unos uspešan!', life: 3000 });
        resetForma();
        loadAvansni(id_predracun);
        refreshAlarm();
      })
      .catch(err => err.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 })));
  };

  const handleDelete = () => {
    if (!selectedAvansniId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali stavku za brisanje.', life: 3000 });
      return;
    }
    confirmDialog({
      message: 'Da li ste sigurni da želite obrisati ovaj zapis?',
      acceptLabel: 'Da', rejectLabel: 'Ne',
      icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
      accept: () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/DeleteAvansniRacun', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({ id: selectedAvansniId }),
        })
          .then(handleErrors)
          .then(() => {
            toast.current.show({ severity: 'success', summary: 'Uspešno obrisano!', life: 3000 });
            resetForma();
            loadAvansni(izabranPredracun?.Izaberi);
            refreshAlarm();
          })
          .catch(err => err.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 })));
      },
    });
  };

  // ─── Slanje avansnog/konačnog na SEF ─────────────────────────────────────────
  const sendAvansKonacniNaSef = (id) => {
    setSefSendingId(id);
    fetch(process.env.REACT_APP_BACKEND_URL + '/sef/SendAvansKonacni', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id }),
    })
      .then(handleErrors)
      .then(data => {
        toast.current.show({
          severity: 'success', summary: 'Poslato na SEF!',
          detail: `SEF Sales ID: ${data.sefSalesInvId || ''}`, life: 4000,
        });
        loadAvansni(izabranPredracun?.Izaberi);
      })
      .catch(err => err.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message, life: 5000 })))
      .finally(() => setSefSendingId(null));
  };

  const handleSendAvansKonacniToSef = (row) => {
    if (!row?.ID) return;
    if (!sefKonfigurisan) {
      toast.current.show({ severity: 'error', summary: t('sef.nijeKonfigurisan'),
        detail: sefRazlog || t('sef.nemaKljucaOpsti'), life: 7000 });
      return;
    }
    const isKonacni = row.id_tip_racuna === 308;
    const poruka = isKonacni
      ? 'Na SEF će biti poslat PREOSTALI iznos predračuna (predračun − već naplaćeni avansi), ne zbir avansnih uplata. Svi povezani avansni moraju već biti poslati na SEF. Da li želite da nastavite?'
      : 'Da li ste sigurni da želite da pošaljete ovaj avansni račun na SEF?';
    confirmDialog({
      message: poruka,
      header: 'Potvrda slanja na SEF',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Da', rejectLabel: 'Ne',
      accept: () => sendAvansKonacniNaSef(row.ID),
    });
  };

  const imaNesposlatihAvansnih = avansniData.some(r => r.id_tip_racuna === 307 && !r.sefSalesInvId);

  // ─── Štampa avansnog/konačnog ────────────────────────────────────────────────
  const handlePrintAvansni = async (idAvansni) => {
    if (!idAvansni) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za štampu.', life: 3000 });
      return;
    }
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/PrintAvansniRacun', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ id: idAvansni }),
      });
      const data = await res.json();
      if (!res.ok || data.message) {
        toast.current.show({ severity: 'error', summary: 'Greška', detail: data.message || 'Greška pri štampi.', life: 4000 });
        return;
      }
      handlePrintInvoice(data);
    } catch {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: 'Greška pri štampi avansnog računa.', life: 3000 });
    }
  };

  const fetchAvansniData = async (idAvansni) => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/PrintAvansniRacun', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: idAvansni }),
    });
    const data = await res.json();
    if (!res.ok || data.message) throw new Error(data.message || 'Greška pri učitavanju podataka.');
    return data;
  };

  const handleIzveziPDFAvansni = async () => {
    if (!selectedAvansniId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za eksport.', life: 3000 });
      return;
    }
    try {
      const data = await fetchAvansniData(selectedAvansniId);
      await exportInvoiceWithFiles({
        podaci: data,
        token: auth.token,
        fileName: `Avansni_${data.RacunBroj || selectedAvansniId}.pdf`,
      });
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message || 'Neuspešan export PDF-a.', life: 4000 });
    }
  };

  const handleIzveziExcelAvansni = async () => {
    if (!selectedAvansniId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za eksport.', life: 3000 });
      return;
    }
    try {
      const data = await fetchAvansniData(selectedAvansniId);
      await exportInvoiceToExcel(data, { token: auth.token }, `Avansni_${data.RacunBroj || selectedAvansniId}.xlsx`);
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message || 'Neuspešan export Excel-a.', life: 4000 });
    }
  };

  // ─── Štampa konačnog ─────────────────────────────────────────────────────────
  const handlePrintKonacni = async (idKonacni) => {
    if (!idKonacni) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za štampu.', life: 3000 });
      return;
    }
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/PrintKonacniRacun', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ id: idKonacni }),
      });
      const data = await res.json();
      if (!res.ok || data.message) {
        toast.current.show({ severity: 'error', summary: 'Greška', detail: data.message || 'Greška pri štampi.', life: 4000 });
        return;
      }
      handlePrintInvoice(data);
    } catch {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: 'Greška pri štampi konačnog računa.', life: 3000 });
    }
  };

  const fetchKonacniData = async (idKonacni) => {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/PrintKonacniRacun', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: idKonacni }),
    });
    const data = await res.json();
    if (!res.ok || data.message) throw new Error(data.message || 'Greška pri učitavanju podataka.');
    return data;
  };

  const handleIzveziPDFKonacni = async () => {
    if (!selectedAvansniId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za eksport.', life: 3000 });
      return;
    }
    try {
      const data = await fetchKonacniData(selectedAvansniId);
      await exportInvoiceWithFiles({
        podaci: data,
        token: auth.token,
        fileName: `Konacni_${data.RacunBroj || selectedAvansniId}.pdf`,
      });
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message || 'Neuspešan export PDF-a.', life: 4000 });
    }
  };

  const handleIzveziExcelKonacni = async () => {
    if (!selectedAvansniId) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje!', detail: 'Niste izabrali zapis za eksport.', life: 3000 });
      return;
    }
    try {
      const data = await fetchKonacniData(selectedAvansniId);
      await exportInvoiceToExcel(data, { token: auth.token }, `Konacni_${data.RacunBroj || selectedAvansniId}.xlsx`);
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: e.message || 'Neuspešan export Excel-a.', life: 4000 });
    }
  };

  // ─── Excel export avansnih ───────────────────────────────────────────────────
  const exportAvansniExcel = async () => {
    if (!avansniData?.length) return;
    const cols = ['Tip', 'Broj', 'Iznos', 'Valuta', 'Datum uplate', 'Napomena', 'Datum unosa'];
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Avansni računi');
    const hr = ws.addRow(cols);
    hr.font = { bold: true };
    avansniData.forEach(row => ws.addRow(cols.map(h => row[h] ?? '')));
    ws.columns.forEach((c, i) => {
      c.width = Math.max(cols[i].length, ...avansniData.map(r => String(r[cols[i]] ?? '').length)) + 2;
    });
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `Avansni - ${izabranPredracun?.['Predracun br'] || 'predracun'}.xlsx`);
  };

  // ─── XML import ──────────────────────────────────────────────────────────────
  const handleXmlUpload = async (e) => {
    const file = e.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('izvod', file);
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/ImportIzvodXML', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + auth.token },
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) {
        toast.current.show({ severity: 'error', summary: 'Greška', detail: data.message, life: 5000 });
        return;
      }
      toast.current.show({
        severity: 'success',
        summary: 'XML uvezen!',
        detail: `Ubačeno: ${data.inserted}, Preskočeno: ${data.skipped}, od Ukupnih: ${data.total}`,
        life: 5000,
      });
      if (data.errors?.length) {
        data.errors.forEach(e => toast.current.show({ severity: 'warn', summary: 'Upozorenje', detail: e, life: 6000 }));
      }
      if (izabranPredracun?.Izaberi) loadAvansni(izabranPredracun.Izaberi);
    } catch {
      toast.current.show({ severity: 'error', summary: 'Greška', detail: 'Neuspešan XML uvoz.', life: 3000 });
    }
  };

  // ─── Config kolona ───────────────────────────────────────────────────────────
  const handleSaveConfig = () => {
    confirmDialog({
      message: 'Sačuvati konfiguraciju kolona?', acceptLabel: 'Da', rejectLabel: 'Ne',
      icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
      accept: () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/config/changeConfig', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({ id_config: 310, parametri: selectedColumns }),
        }).then(handleErrors)
          .then(() => toast.current.show({ severity: 'success', summary: 'Konfiguracija sačuvana!', life: 3000 }))
          .catch(() => {});
      },
    });
  };

  // ─── Excel export ────────────────────────────────────────────────────────────
  const exportExcel = async () => {
    if (!selectedColumns?.length || !tableData?.length) return;
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Avans predračuni');
    const hr = ws.addRow(selectedColumns);
    hr.font = { bold: true };
    tableData.forEach(row => ws.addRow(selectedColumns.map(h => row[h] ?? '')));
    ws.columns.forEach((c, i) => {
      c.width = Math.max(selectedColumns[i].length, ...tableData.map(r => String(r[selectedColumns[i]] ?? '').length)) + 2;
    });
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `Avans predracuni - ${company.companyName}.xlsx`);
  };

  const isFileColumn = (f) => f.startsWith('Izaberi') || f.includes('Dokument') || f.endsWith('LK') || f.endsWith('VD');

  const previewBodyTemplate = (rowData, field) => {
    if (field !== 'Izaberi') return rowData[field] || '-';
    return (
      <Button label={t('nova.izaberi')} icon="pi pi-eye" className="p-button-text p-button-sm"
        onClick={() => chooseInvoice(rowData)} tooltip="Izaberi predračun" tooltipOptions={{ position: 'top' }} />
    );
  };

  const headerPredracuni = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} />
        {izabranPredracun && (
          <Button label={t('nova.editPredracun')} icon="pi pi-pencil" severity="info"
            onClick={handleEditPredracun} />
        )}
        <FileUpload mode="basic" name="izvod" accept=".xml"
          chooseLabel="Uvezi XML izvod" auto customUpload
          uploadHandler={handleXmlUpload} />
      </div>
      <input type="search" onInput={e => setGlobalFilter(e.target.value)}
        placeholder={t('nova.phPretraga')} className="p-inputtext p-component" />
    </div>
  );

  // ─── Sažetak avansnih ────────────────────────────────────────────────────────
  const sazetakRed = avansniData?.[0];
  // Fallback kad nema ni jednog avansnog zapisa: čitamo iz reda predračuna u tabeli
  // 'Valute iznosa' = label iz stavke.iznosValuta (npr. "EUR") — ispravno, jer neto je u toj valuti.
  // 'Valuta' = label iz faktura.valuta (može biti "RSD" i za EUR-priced stavke) — netačno za prikaz.
  const _valutaFallback = izabranPredracun?.['Valute iznosa'] || izabranPredracun?.['Valuta'] || 'RSD';
  const _iznosFallback  = parseFloat(izabranPredracun?.Iznos) || 0;
  // Kurs iz tabele (f.kurs) može biti 1 ili null za predračune kreirane bez kursa.
  // Kad je ≤1 a valuta nije RSD, ne koristimo taj kurs — SP ima NBS fallback koji je pouzdan.
  const _kursFallback   = (() => {
    const k = parseFloat(izabranPredracun?.Kurs);
    return k > 1 ? k : null; // null = kurs nije pouzdano poznat na frontendu
  })();

  const iznosPredracuna    = sazetakRed ? (parseFloat(sazetakRed.IznosPredracuna) || 0) : _iznosFallback;
  const sumaAvansnih       = sazetakRed ? (parseFloat(sazetakRed.SumaAvansnih)   || 0) : 0;
  const preostalo          = sazetakRed ? (parseFloat(sazetakRed.Preostalo)       || 0) : _iznosFallback;
  const iznosPredracunaRSD = sazetakRed ? (parseFloat(sazetakRed.IznosPredracunaRSD) || 0) : _iznosFallback * _kursFallback;
  const sumaAvansnihRSD    = sazetakRed ? (parseFloat(sazetakRed.SumaAvansnihRSD)    || 0) : 0;
  const preostaloRSD       = sazetakRed ? (parseFloat(sazetakRed.PreostaloRSD)       || 0)
    : (_kursFallback ? _iznosFallback * _kursFallback : null); // null = RSD nepoznat bez SP-a
  const valutaPredracuna   = sazetakRed?.ValutaPredracuna || _valutaFallback;
  const jeDevizniPredracun = valutaPredracuna !== 'RSD';

  const hasKonacni = avansniData.some(r => r.id_tip_racuna === 308 || (r.id_faktura_konacna && r.IsKonacnaAktivna));
  // Avansni bez konačnog — proverava i stari (BrojVeza) i novi (id_faktura_konacna) mehanizam.
  // IsKonacnaAktivna = false kad je konačna stornirana → avans se tretira kao bez konačnog.
  const avansniTekuciMesecBezKonacnog = avansniData.filter(r =>
    r.id_tip_racuna === 307 && (!r.BrojVeza || r.BrojVeza === 0) && (!r.id_faktura_konacna || !r.IsKonacnaAktivna)
  ).length;

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div>
        <Button
          id={aktivniTab === 0 ? 'activeButton' : undefined}
          label={t('nova.predracuni')}
          style={{ fontSize: 'smaller', marginBottom: '1%' }}
          onClick={() => setAktivniTab(0)}
        />
        <Button
          id={aktivniTab === 1 ? 'activeButton' : undefined}
          label={t('nova.avansniRacuni')}
          className="mt-3 zaposleniShift"
          style={{ fontSize: 'smaller', marginBottom: '1%' }}
          onClick={() => setAktivniTab(1)}
        />
      </div>

      {aktivniTab === 0 && (
      <div>

      {/* ─── Kolone config ─── */}
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '0.5em' }}>
        <div style={{ width: '30%' }}>
          {allColumns.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <MultiSelect value={selectedColumns} options={allColumns}
                onChange={e => setSelectedColumns(originalColumnOrder.filter(k => e.value.includes(k)))}
                optionLabel="label" display="chip" placeholder={t('nova.kolone')} style={{ width: '100%' }}
                showSelectAll filter filterPlaceholder="Pretraži" maxSelectedLabels={3}
                selectedItemsLabel="{0} kolona" />
              <button onClick={handleSaveConfig} style={{ marginLeft: '4px' }} className="configSaveButton">
                <i className="pi pi-save" />
              </button>
            </div>
          )}
        </div>
        {izabranPredracun && (
          <p className="infoPoruka" style={{ margin: 0, marginLeft: '1%', display: 'flex', alignItems: 'center' }}>
            Predračun selektovan — prikazuju se avansni/konačni računi ispod.
          </p>
        )}
      </div>

      {/* ─── Tabela predračuna ─── */}
      <Tooltip target=".export-buttons>button" position="bottom" />
      <DataTable value={tableData} paginator rows={10} first={first} globalFilter={globalFilter}
        onPage={e => setFirst(e.first)} scrollable header={headerPredracuni} scrollHeight="400px"
        className="stavke-tabela"
        emptyMessage={t('common.noData')} loading={tableData === null} resizableColumns columnResizeMode="expand"
        rowClassName={row => {
          const classes = [];
          const id = String(getId(row));
          if (isSelected(row)) classes.push('selected-row');
          if (alarmPredracunIds.has(id)) classes.push('row-red');
          else if (orangePredracunIds.has(id)) classes.push('row-orange');
          return classes.join(' ');
        }}>
        {selectedColumns.map(colKey => {
          const meta = allColumns.find(c => c.value === colKey);
          if (colKey === 'Status') return (
            <Column key="Status" field="Status" header={t('nova.status')} sortable style={{ minWidth: '110px' }}
              body={rowData => {
                const isStorno = rowData['Status'] === 'Stornirana';
                return (
                  <span style={{
                    fontWeight: 600, fontSize: '0.82rem',
                    color: isStorno ? '#888' : '#2e7d32',
                    textDecoration: isStorno ? 'line-through' : 'none'
                  }}>
                    {isStorno ? 'Stornirana' : 'Aktivna'}
                  </span>
                );
              }} />
          );
          return (
            <Column key={colKey} field={colKey} header={meta?.label || colKey} sortable
              body={rowData => {
                if (colKey === 'Iznos') return rowData.Iznos != null ? `${parseFloat(rowData.Iznos).toFixed(2)} ${rowData.Valuta || 'RSD'}` : '-';
                if (colKey === 'Bruto' || colKey === 'Neto') return rowData[colKey] != null ? `${parseFloat(rowData[colKey]).toFixed(2)} ${rowData.Valuta || 'RSD'}` : '-';
                return isFileColumn(colKey) ? previewBodyTemplate(rowData, colKey) : (rowData[colKey] || '-');
              }}
              style={{ minWidth: '130px' }} />
          );
        })}
      </DataTable>

      {/* ─── Sekcija avansnih/konačnih ─── */}
      {izabranPredracun && (
        <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        {hasKonacni ? (
          <div style={{
            width: '100%', padding: '8px 14px', marginBottom: '4px',
            background: '#e8f5e9', border: '1px solid #2e7d32', borderRadius: '6px',
            display: 'flex', alignItems: 'center', gap: '10px', color: '#1b5e20', fontWeight: 600
          }}>
            <i className="pi pi-check-circle" />
            Izdat je konačni račun za ovaj predračun. Preostalo za uplatu:&nbsp;
            <strong>{preostalo.toFixed(2)} {valutaPredracuna}</strong>
            {jeDevizniPredracun && <span>&nbsp;({preostaloRSD.toFixed(2)} RSD)</span>}
          </div>
        ) : avansniTekuciMesecBezKonacnog > 0 ? (
          <div style={{
            width: '100%', padding: '8px 14px', marginBottom: '4px',
            background: '#fff3e0', border: '1px solid #e65100', borderRadius: '6px',
            display: 'flex', alignItems: 'center', gap: '10px', color: '#e65100', fontWeight: 600
          }}>
            <i className="pi pi-exclamation-triangle" />
            Postoji {avansniTekuciMesecBezKonacnog} avans(a) bez izdatog konačnog računa.
          </div>
        ) : null}

        {/* ─── Forma + Tabela ─── */}
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', width: '100%' }}>
          {/* Forma */}
          <div style={{ flex: '0 0 280px', minWidth: '260px' }}>
            <Card>
              <h5 style={{ margin: '0 0 0.8rem' }}>
                {selectedAvansniId ? 'Izmena zapisa' : 'Novi avansni'}
              </h5>
              {avansniData.some(r => r.id_tip_racuna === 307) && (
                <Button label={t('nova.kreirajKonacni')} icon="pi pi-file" severity="success"
                  style={{ width: '100%', marginBottom: '0.6rem' }} onClick={handleKreirajKonacni}
                  tooltip="Kreira novu konačnu fakturu (Standardna) povezanu sa ovim predračunom"
                  tooltipOptions={{ position: 'top' }} />
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                <div>
                  <label>{t('nova.tip')}: <span className="iz-obavezno">*</span></label>
                  <Dropdown name="id_tip_racuna" value={formData.id_tip_racuna}
                    options={(tipoviOptions.length ? tipoviOptions : [{ label: 'Avansna', value: 307 }, { label: 'Konačna', value: 308 }])
                      .filter(o => o.value !== 308 || formData.id_tip_racuna === 308)}
                    onChange={handleFormChange} style={{ width: '100%' }} />
                </div>
                <div>
                  <label>{t('nova.iznos')}: {formData.id_tip_racuna === 307 && <span className="iz-obavezno">*</span>}</label>
                  <InputNumber name="Iznos" value={formData.Iznos} onValueChange={handleFormChange}
                    minFractionDigits={2} maxFractionDigits={2} style={{ width: '100%' }}
                    disabled={formData.id_tip_racuna === 308}
                    invalid={formSubmitted && formData.id_tip_racuna === 307 && !formData.Iznos}
                    placeholder={(() => {
                      if (formData.id_tip_racuna === 308) return '';
                      const selLabel = valuteOptions.find(o => o.value === formData.IznosValuta)?.label || '';
                      const wantRsd = selLabel === 'RSD' && jeDevizniPredracun;
                      if (wantRsd && preostaloRSD == null) return preostalo > 0 ? `Max: ${preostalo.toFixed(2)} ${valutaPredracuna}` : '';
                      const pr = wantRsd ? preostaloRSD : preostalo;
                      const lbl = wantRsd ? 'RSD' : valutaPredracuna;
                      return pr > 0 ? `Max: ${pr.toFixed(2)} ${lbl}` : '';
                    })()}
                  />
                  {formData.id_tip_racuna === 307 && izabranPredracun && (() => {
                    const selLabel = valuteOptions.find(o => o.value === formData.IznosValuta)?.label || '';
                    const wantRsd = selLabel === 'RSD' && jeDevizniPredracun;
                    if (wantRsd && preostaloRSD == null) return (
                      <small style={{ color: '#666', marginTop: '2px', display: 'block' }}>
                        Max: <strong>{preostalo.toFixed(2)} {valutaPredracuna}</strong>
                      </small>
                    );
                    const pr = wantRsd ? preostaloRSD : preostalo;
                    const lbl = wantRsd ? 'RSD' : valutaPredracuna;
                    return (
                      <small style={{ color: preostalo <= 0 ? 'red' : '#666', marginTop: '2px', display: 'block' }}>
                        Preostalo za uplatu: <strong>{pr.toFixed(2)} {lbl}</strong>
                      </small>
                    );
                  })()}
                </div>
                <div>
                  <label>{t('nova.valuta')}:</label>
                  <CustomDropdown name="IznosValuta" value={formData.IznosValuta} options={valuteOptions}
                    onChange={handleFormChange} style={{ width: '100%' }} placeholder={t('nova.phValutu')}
                    optionLabel="label" showClear={false} />
                </div>
                {formData.id_tip_racuna === 307 && (
                  <div>
                    <label>{t('nova.datumUplate')}:</label>
                    <Calendar name="datumUplate" value={formData.datumUplate}
                      onChange={handleFormChange} dateFormat="dd.mm.yy" showIcon
                      style={{ width: '100%' }} />
                  </div>
                )}
                {formData.id_tip_racuna === 308 && (
                  <div>
                    <label>{t('nova.mesecKonacnog')}:</label>
                    <Calendar value={mesecKonacni} onChange={e => {
                        setMesecKonacni(e.value);
                        loadPreviewKonacni(e.value, izabranPredracun?.Izaberi);
                      }}
                      view="month" dateFormat="mm/yy" showIcon
                      style={{ width: '100%' }} placeholder={t('nova.phMesec')} />
                    {previewKonacni.length > 0 && (
                      <div style={{ fontSize: '11px', color: '#555', marginTop: '4px' }}>
                        {previewKonacni.length} avans(a), ukupno: <strong>{parseFloat(previewKonacni[0]?.UkupnoZaKonacni || 0).toFixed(2)}</strong>
                      </div>
                    )}
                  </div>
                )}
                <div>
                  <label>{t('nova.napomena')}:</label>
                  <InputTextarea name="Napomena" value={formData.Napomena} onChange={handleFormChange}
                    rows={2} style={{ width: '100%' }} />
                </div>

                {iznosPredracuna > 0 && (
                  <div style={{ fontSize: '12px', color: '#555', borderTop: '1px solid #eee', paddingTop: '0.5rem' }}>
                    <div>Predračun: <strong>{iznosPredracuna.toFixed(2)} {valutaPredracuna}</strong>{jeDevizniPredracun && ` (${iznosPredracunaRSD.toFixed(2)} RSD)`}</div>
                    <div>Uplaćeno: <strong>{sumaAvansnih.toFixed(2)} {valutaPredracuna}</strong>{jeDevizniPredracun && ` (${sumaAvansnihRSD.toFixed(2)} RSD)`}</div>
                    <div>Preostalo: <strong style={{ color: preostalo < 0 ? 'red' : 'green' }}>{preostalo.toFixed(2)} {valutaPredracuna}</strong>{jeDevizniPredracun && ` (${preostaloRSD.toFixed(2)} RSD)`}</div>
                  </div>
                )}

                <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                  <Button label={selectedAvansniId ? 'Sačuvaj' : 'Unos'} icon="pi pi-check"
                    className="p-button-success" style={{ flex: 1 }} onClick={handleSave} />
                  {selectedAvansniId && (
                    <Button label={t('nova.brisi')} icon="pi pi-trash" className="p-button-danger"
                      style={{ flex: 1 }} onClick={handleDelete} />
                  )}
                  <Button label={t('nova.resetuj')} icon="pi pi-refresh" className="p-button-secondary"
                    style={{ flex: 1 }} onClick={resetForma} />
                </div>
              </div>
            </Card>
          </div>

          {/* Tabela avansnih/konačnih */}
          <div style={{ flex: 1, minWidth: '300px' }}>
                          {!statusProvereOK && (
                <div style={{ marginBottom: '0.8rem', padding: '0.55rem 0.8rem', background: '#fff3e0', border: '1px solid #ffa000', borderRadius: 6, display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#e65100', fontWeight: 500, fontSize: '0.82rem' }}>
                  <i className="pi pi-lock" />
                  Predračun nije proveran — unos avansnih/konačnih nije dozvoljeno.
                </div>
              )}
            <DataTable value={avansniData} loading={avansniLoading} emptyMessage="Nema avansnih/konačnih računa"
              scrollable scrollHeight="300px" resizableColumns columnResizeMode="expand"
              rowClassName={row => String(row.ID) === String(selectedAvansniId) ? 'selected-row' : ''}
              className="stavke-tabela"
              header={
                <div className="export-buttons fakture-stavke-header fakture-header-lomi">
                  <div className="fakture-stavke-radnje">
                    <Button type="button" icon="pi pi-file-excel" severity="success" rounded
                      onClick={exportAvansniExcel} tooltip="Izvezi tabelu u Excel" tooltipOptions={{ position: 'top' }} />
                    {selectedAvansniId && (
                      <Button type="button" icon="pi pi-trash" severity="danger" rounded
                        onClick={handleDelete} tooltip="Briši izabrani" tooltipOptions={{ position: 'top' }} />
                    )}
                  </div>
                  <div className="fakture-stavke-radnje">
                    {(() => {
                      const selRow = avansniData.find(r => String(r.ID) === String(selectedAvansniId));
                      const isKonacni = selRow?.id_tip_racuna === 308;
                      const vecPoslato = !!selRow?.sefSalesInvId;
                      const blokiranoKonacni = isKonacni && imaNesposlatihAvansnih;
                      return (<>
                        <Button label={t('nova.stampa')} type="button"
                          disabled={!selectedAvansniId}
                          onClick={() => isKonacni ? handlePrintKonacni(selectedAvansniId) : handlePrintAvansni(selectedAvansniId)} />
                        <Button label={t('nova.izveziPdf')} type="button"
                          disabled={!selectedAvansniId}
                          onClick={isKonacni ? handleIzveziPDFKonacni : handleIzveziPDFAvansni} />
                        <Button label={t('nova.izveziExcel')} type="button"
                          disabled={!selectedAvansniId}
                          onClick={isKonacni ? handleIzveziExcelKonacni : handleIzveziExcelAvansni} />
                        {/* Konačni (308) se ne šalje više direktno na SEF odavde — prava konačna
                            faktura se kreira dugmetom "Kreiraj Konačni" i šalje kroz NovaDinarska. */}
                        {sefKonfigurisan && !isKonacni && (
                          <Button label={sefSendingId === selRow?.ID ? 'Slanje...' : (vecPoslato ? 'Poslato na SEF' : 'Pošalji na SEF')}
                            type="button" className="p-button-success"
                            disabled={!selectedAvansniId || vecPoslato || sefSendingId === selRow?.ID}
                            onClick={() => handleSendAvansKonacniToSef(selRow)} />
                        )}
                      </>);
                    })()}
                  </div>
                </div>
              }>
              <Column header={t('nova.izaberi')} style={{ minWidth: '80px' }}
                body={row => (
                  <Button label={t('nova.izaberi')} icon="pi pi-eye" className="p-button-text p-button-sm"
                    onClick={() => chooseAvansni(row)} />
                )} />
              <Column field="Tip" header={t('nova.tip')} style={{ minWidth: '90px' }} />
              <Column field="BrojPrikaz" header={t('nova.broj')} style={{ minWidth: '90px' }} />
              <Column field="Iznos" header={t('nova.iznos')} style={{ minWidth: '120px' }}
                body={row => `${parseFloat(row.Iznos).toFixed(2)} ${row.Valuta || 'RSD'}`} />
              <Column field="Datum uplate" header={t('nova.datumUplate')} style={{ minWidth: '100px' }} />
              <Column field="Napomena" header={t('nova.napomena')} style={{ minWidth: '150px' }} />
              <Column field="Datum unosa" header={t('nova.unet')} style={{ minWidth: '90px' }} />
              <Column header={t('nova.sefStatus')} style={{ minWidth: '110px' }}
                body={row => row.sefSalesInvId
                  ? <span style={{ color: '#2e7d32', fontWeight: 600 }}>{row.sefStatus || 'Poslato'}</span>
                  : <span style={{ color: '#999' }}>—</span>} />
              <Column field="sefKomentar" header={t('nova.sefKomentar')} style={{ minWidth: '180px' }}
                body={row => row.sefKomentar || <span style={{ color: '#999' }}>—</span>} />
            </DataTable>
          </div>
        </div>
        </div>
      )}
      </div>
      )}

      {aktivniTab === 1 && (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5em' }}>
          <MultiSelect value={selectedSviAvansniColumns} options={sviAvansniColumnsAll}
            onChange={e => setSelectedSviAvansniColumns(sviAvansniColumnsAll.map(c => c.value).filter(v => e.value.includes(v)))}
            optionLabel="label" display="chip" placeholder={t('nova.kolone')} style={{ width: '30%' }}
            showSelectAll filter filterPlaceholder="Pretraži" maxSelectedLabels={3}
            selectedItemsLabel="{0} kolona" />
        </div>
        <DataTable value={sviAvansniData} paginator rows={15} loading={sviAvansniData === null}
          globalFilter={globalFilterAvansni}
          emptyMessage="Nema izdatih avansnih faktura" scrollable scrollHeight="60vh"
          resizableColumns columnResizeMode="expand"
          header={
            <div className="export-buttons fakture-stavke-header stavke-tabela">
              <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-refresh" rounded onClick={loadSviAvansni}
                  tooltip="Osveži" tooltipOptions={{ position: 'top' }} />
              </div>
              <input type="search" onInput={e => setGlobalFilterAvansni(e.target.value)}
                placeholder={t('common.search')} className="p-inputtext p-component" />
            </div>
          }>
          {selectedSviAvansniColumns.includes('BrojPrikaz') &&
            <Column field="BrojPrikaz" header={t('nova.brojAvansnog')} sortable style={{ minWidth: '110px' }} />}
          {selectedSviAvansniColumns.includes('BrojPredracuna') &&
            <Column field="BrojPredracuna" header={t('nova.predracun')} sortable style={{ minWidth: '130px' }} />}
          {selectedSviAvansniColumns.includes('Klijent') &&
            <Column field="Klijent" header={t('nova.klijent')} sortable style={{ minWidth: '180px' }} />}
          {selectedSviAvansniColumns.includes('Iznos') &&
            <Column field="Iznos" header={t('nova.iznos')} sortable style={{ minWidth: '120px' }}
              body={row => `${parseFloat(row.Iznos).toFixed(2)} ${row.Valuta || 'RSD'}`} />}
          {selectedSviAvansniColumns.includes('Datum uplate') &&
            <Column field="Datum uplate" header={t('nova.datumUplate')} sortable style={{ minWidth: '100px' }} />}
          {selectedSviAvansniColumns.includes('Datum unosa') &&
            <Column field="Datum unosa" header={t('nova.kreiran')} sortable style={{ minWidth: '100px' }} />}
          {selectedSviAvansniColumns.includes('sefStatus') &&
            <Column header={t('nova.sefStatus')} style={{ minWidth: '110px' }}
              body={row => row.sefSalesInvId
                ? <span style={{ color: '#2e7d32', fontWeight: 600 }}>{row.sefStatus || 'Poslato'}</span>
                : <span style={{ color: '#999' }}>—</span>} />}
          {selectedSviAvansniColumns.includes('sefKomentar') &&
            <Column field="sefKomentar" header={t('nova.sefKomentar')} style={{ minWidth: '180px' }}
              body={row => row.sefKomentar || <span style={{ color: '#999' }}>—</span>} />}
        </DataTable>
      </div>
      )}
    </div>
  );
};

export default PregledPredracuna;
